/* Rapid Sport — product page behaviour.
   Sticky details card only while it fits in the viewport. Horizon pins .product-details
   (sticky-content--desktop); a card taller than the screen then slides past the end of the
   section and over the footer. When it doesn't fit, .rs-unstick drops it back into normal flow.
   v2: the fit test now counts the card's top margin and its real sticky top offset, and a
   scroll guard unsticks the card if it ever runs past the bottom of the product grid. */
(function () {
  function px(v) { return parseFloat(v) || 0; }
  function init() {
    var cards = document.querySelectorAll('.product-information .product-details.sticky-content--desktop');
    if (!cards.length) return;
    var mq = window.matchMedia('(min-width: 750px)');
    function fits(c) {
      var cs = getComputedStyle(c);
      var top = Math.max(px(cs.top), 132);
      return c.offsetHeight + px(cs.marginTop) + px(cs.marginBottom) + top + 24 <= window.innerHeight;
    }
    function check() {
      cards.forEach(function (c) {
        c.classList.remove('rs-unstick');
        if (mq.matches && !fits(c)) c.classList.add('rs-unstick');
      });
      guard();
    }
    var ticking = false;
    function guard() {
      ticking = false;
      if (!mq.matches) return;
      cards.forEach(function (c) {
        if (c.classList.contains('rs-unstick')) return;
        var grid = c.closest('.product-information__grid') || c.parentElement;
        if (c.getBoundingClientRect().bottom > grid.getBoundingClientRect().bottom + 1) c.classList.add('rs-unstick');
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(guard); } }
    check();
    window.addEventListener('resize', check, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    if (mq.addEventListener) mq.addEventListener('change', check);
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(check);
      cards.forEach(function (c) { ro.observe(c); });
    }
    window.addEventListener('load', check);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
